.container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 100%;
  width: 100%;
  background-image: url(/images/dramatic-pause.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.wrapper {
  position: absolute;
  top: 57%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 2rem;

  @media screen and (min-width: $bp-small) {
    gap: 2.4rem;
  }

  @media screen and (min-width: $bp-medium) {
    gap: 3.2rem;
  }
}

.text {
  font-size: 1.6rem;
  color: var(--color-grayscale-anti-flash-white);

  @media screen and (min-width: $bp-small) {
    font-size: 2rem;
  }

  @media screen and (min-width: $bp-medium) {
    font-size: 2.4rem;
  }
}

.button-wrapper {
  width: 24rem;
  max-width: 80vw;

  & > button {
    &[data-full='true'] {
      height: 3.2rem;
    }
  }
}
